import { TaskType } from '../../main/types/asset/asset.enums.ts';

export const SOUNDS_WITH_ARROW_LESSON_TASK_TYPES = [
  TaskType.Sounds,
  TaskType.SoundsIntroduction,
  TaskType.SoundsReview,
  TaskType.ChildTouchesSounds,
  TaskType.WordReading,
  TaskType.Rhyming,
];

export const SAYING_SOUNDS_LESSON_TASK_TYPES = [
  TaskType.LessonComplete,
  TaskType.NewCritter,
  TaskType.SayItFast,
  TaskType.SayItFastReview,
  TaskType.SayTheSounds,
  TaskType.SayTheSoundsReview,
];

export const SOUNDS_WRITING_LESSON_TASK_TYPES = [TaskType.SoundsWriting];

export const PICTURE_COMPREHENSION_LESSON_TASK_TYPES = [TaskType.PictureComprehension];

export const STORY_READING_LESSON_TASK_TYPES = [
  TaskType.FirstReading,
  TaskType.SecondReading,
  TaskType.CritterReadsTheFastWay,
  TaskType.ReadingTheFastWay,
  TaskType.WordFinding,
];

export const CAPITAL_LETTERS_LESSON_TASK_TYPES = [TaskType.CapitalLetters];

export const SUPPORTED_TASK_TYPES = [
  ...SOUNDS_WITH_ARROW_LESSON_TASK_TYPES,
  ...SAYING_SOUNDS_LESSON_TASK_TYPES,
  ...SOUNDS_WRITING_LESSON_TASK_TYPES,
  ...PICTURE_COMPREHENSION_LESSON_TASK_TYPES,
  ...STORY_READING_LESSON_TASK_TYPES,
  ...CAPITAL_LETTERS_LESSON_TASK_TYPES,
];
